import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./vales.module.css";
import { IoCloseSharp } from "react-icons/io5";
import Swal from 'sweetalert2';
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Select from 'react-select'

export default function ModalVales(props) {
    const { show, setShow, roles, dataEdit, setDataEdit, estados, municipios, codigos, handleUpdate, genders,companieAll,distribuidores,estatusAll,companieSelectM,distribuidorSelectM,estatusSelectM} = props;
    const [number, setNumber] = useState("");
    const [total, setTotal] = useState("");
    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
      }).split('/').reverse().join('-'));
    const [expiration, setExpiration] = useState("");
    const [description, setDescription] = useState("");
    const [municipalFilterAval, setMunicipalFilterAval] = useState([]);
    const [postalCodeFilterAval, setPostalCodeFilterAval] = useState([]);
    const [stateSelectAval, setStateSelectAval] = useState(null);
    const [municipalSelectAval, setMunicipalSelectAval] = useState(null);
    const [postalCodeSelectAval, setPostalCodeSelectAval] = useState(null);
    const [gendersSelectAval, setGendersSelectAval] = useState(null);

    const [companieSelect, setCompanieSelect] = useState(null);
    const [distribuidorSelect, setDistribuidorSelect] = useState(null);
    const [estatusSelect, setEstatusSelect] = useState(null);

    const [menu06Data, setMenu06Data] = useState({
        idBacking: 0,
        names: "",
        fathersLastName: "",
        mothersLastName: "",
        dateOfBirth: "",
        credentialNumber: "",
        populationRegistrationCode: "",
        addressDescription: "",
        phoneNumber: "",
        addressReferences: ""
    });
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
    const handleAgregar = () => {
        if (number==="" || total==="" || fecha==="" || expiration ==="" || companieSelect === null) {
            Swal.fire({
                text: 'Favor de llenar todos los campos',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            })
        }
        else {
            let payload = {
                "id":dataEdit!=null?dataEdit.id:0,
                "companiesCentralOfficeId": companieSelect.value,
                "distributorId": distribuidorSelect.value,
                "number": number,
                "amount": total,
                "date": fecha,
                "dateExpiration": expiration,
                "description": description,
                "statusId": estatusSelect.value
              }
            let URL = dataEdit != null ? SERVICE.updateVale : SERVICE.setVale;
            let METHOD = dataEdit != null ? "PUT" : "POST";
            api(URL, payload, METHOD)
                .then((data) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Vale Guardado correctamente",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    handleUpdate();
                    setShow(false);
                })
                .catch((err) => {
                    console.log(err);
                })
        }

    }
    useEffect(() => {
        if (!show && roles.length > 0) {
            // setEmail("");
            // setKey1("");
            // setKey2("");
            // setName("");
            // setLastName("");
            // setUserName("");
            // setRol(roles[0].id);
            // setDataEdit(null);
        }
    }, [show, roles])
    useEffect(() => {
        if (!show) {
            setNumber("");
            setTotal("");
            setDescription("");
            setFecha("");
            setExpiration("");
            setCompanieSelect(null);
            setDistribuidorSelect(null);
            setEstatusSelect(null);
            setDataEdit(null);
        }
        
    }, [show])
    function formatDateForInput(dateString) {
        // Dividir la fecha y hora
        const [datePart] = dateString.split(' ');

        // Dividir día, mes y año
        const [day, month, year] = datePart.split('/');

        // Formatear a YYYY-MM-DD (formato que acepta input date)
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    const handleChangeState = (valueSelect, updateActual = true) => {
        if (valueSelect != null && codigos && codigos.length > 0) {
            if (updateActual) {
                setMunicipalSelectAval(null);
                setPostalCodeSelectAval(null);
            }
            let ArrayTemp = [];
            for (let index = 0; index < municipios.length; index++) {
                const element = municipios[index];
                if (element.stateId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            setStateSelectAval(valueSelect);
            setMunicipalFilterAval(ArrayTemp);
        }
    }
    const handleChangeMunicipal = (valueSelect, updateActual = true) => {
        if (valueSelect != null && municipios && municipios.length > 0) {
            if (updateActual) {
                setPostalCodeSelectAval(null);
            }
            let ArrayTemp = [];
            for (let index = 0; index < codigos.length; index++) {
                const element = codigos[index];
                if (element.municipalityId === valueSelect.value) {
                    ArrayTemp.push(element);
                }
            }
            setMunicipalSelectAval(valueSelect);
            setPostalCodeFilterAval(ArrayTemp);
        }
    }
    useEffect(() => {
        if (dataEdit != null) {
            setNumber(dataEdit.number);
            setTotal(dataEdit.amount);
            setDescription(dataEdit.description);
            setFecha(dataEdit.date.split('T')[0]);
            setExpiration(dataEdit.dateExpiration.split('T')[0]);
            setCompanieSelect(null);
            setDistribuidorSelect(null);
            setEstatusSelect(null);
            let search = companieAll.findIndex(item => item.value == dataEdit.companiesCentralOfficeId);
            if (search !== -1)
                setCompanieSelect(companieAll[search]);
            search = distribuidores.findIndex(item => item.value == dataEdit.distributorId);
            if (search !== -1)
                setDistribuidorSelect(distribuidores[search]);
            search = estatusAll.findIndex(item => item.value == dataEdit.statusId);
            if (search !== -1)
                setEstatusSelect(estatusAll[search]);
        }
        else{
            setFecha(new Date().toLocaleDateString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                timeZone: 'America/Mexico_City'
              }).split('/').reverse().join('-'));
            if(companieSelectM!=null){
                setCompanieSelect(companieSelectM)
            }
            if(estatusSelectM!=null){
                setEstatusSelect(estatusSelectM)
            }
            if(distribuidorSelectM!=null){
                setDistribuidorSelect(distribuidorSelectM)
            }
        }
    }, [dataEdit,companieSelectM,estatusSelectM,distribuidorSelectM])
    return (
        <>
            <div className={styles.bodyModal} style={{ display: show ? "" : "none" }}>
                <div className={`${styles.containerFormMain} animate__animated animate__fadeInDown`} style={{ display: show ? "" : "none" }}>
                    <div className={styles.headerForm}>
                        <h5>{dataEdit != null ? "Editar Vale" : "Nuevo vale"}</h5>
                        <div className={styles.icon} onClick={() => setShow(false)}>
                            <IoCloseSharp />
                        </div>

                    </div>

                    <div className={styles.containerForm}>
                        <div className={styles.itemForm} style={{ width: "50%", zIndex: 2 }}>
                            <label class="form-label">Empresa: </label>
                            <Select isClearable={true} options={companieAll} class="form-control" placeholder="Seleccione una Empresa" value={companieSelect} onChange={(e) => setCompanieSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%", zIndex: 2 }}>
                            <label class="form-label">Distribuidor: </label>
                            <Select isClearable={true} options={distribuidores} class="form-control" placeholder="Seleccione un Distribuidor" value={distribuidorSelect} onChange={(e) => setDistribuidorSelect(e)} />
                        </div>
                       
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Numero de vale:</label>
                            <input type="text" class="form-control" placeholder="#" value={number} onChange={(e) => setNumber(e.target.value )} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Monto del vale:</label>
                            <input type="number" class="form-control" placeholder="$" value={total} onChange={(e) => setTotal(e.target.value )} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "67%" }}>
                            <label class="form-label">Descripción:</label>
                            <input type="text" class="form-control" placeholder="Descripción" value={description} onChange={(e) => setDescription( e.target.value )} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "33%", zIndex: 1 }}>
                            <label class="form-label">Estatus: </label>
                            <Select isClearable={true} options={estatusAll} class="form-control" placeholder="Seleccione estatus" value={estatusSelect} onChange={(e) => setEstatusSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Fecha de vale: </label>
                            <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={fecha} onChange={(e) => setFecha(e.target.value )} />
                        </div>
                        <div className={styles.itemForm} style={{ width: "50%" }}>
                            <label class="form-label">Fecha de expiración: </label>
                            <input type="date" data-date-format="DD MMMM YYYY" class="form-control" placeholder="" value={expiration} onChange={(e) => setExpiration( e.target.value )} />
                        </div>
                        
                    </div>
                    <div className={styles.containerBtn}>
                        <button className='btn btn-success' onClick={handleAgregar}>{dataEdit != null ? "Editar" : "Crear"}</button>&nbsp;&nbsp;
                        <button className='btn btn-danger' onClick={() => setShow(false)}>Cancelar</button>
                    </div>
                </div>
            </div>
        </>
    );
}